import { createSelector } from 'reselect'
import { getCompany } from './company'

export const getProductPlan = createSelector(getCompany, company => {
  if (!company) return null

  return company.product_plan
})
